import config from '@/config'

export const COMPANY_NAME = 'The Neat Company'

export const APP_NAME = 'sentinel'

export const URLS = {
  chatWithAgent:
    'https://home-c6.incontact.com/incontact/chatclient/chatclient.aspx?poc=a709c778-7fe9-4ba7-9a72-75561856ac6c&bu=4593321',
  contactSupport: 'https://support.neat.com/contact-support/',
  helpCenter: 'https://support.neat.com/customerservice/reset-your-password-and-login-issues',
  plansPricing: 'https://www.neat.com/pricing/',
  privacyPolicy: 'https://www.neat.com/policies/privacy',
  signUp: 'https://www.neat.com/plans-pricing/',
  ssoIntuit: `${config.api.cloud}/intuit/session/open_id?source=neat_web_v2`,
  support: 'https://support.neat.com/',
  supportTicket: 'http://support.neat.com/support/create-case-pw/',
  termsAndConditions: 'https://www.neat.com/terms-conditions/',
}

export const SCOPE = {
  APP_NEAT_COM: 'APP_NEAT_COM',
  JAWN: 'JAWN',
  NEMO_IOS: 'NEMO_IOS',
  NEMO_ANDROID: 'NEMO_ANDROID',
  RAVEN: 'RAVEN',
  SCANSNAP: 'SCANSNAP',
  SCISSORS_MAC: 'SCISSORS_MAC',
  SCISSORS_WINDOWS: 'SCISSORS_WINDOWS',
  SSP: 'SSP',
  NEAT_COM: 'NEAT_COM',
}

export const OAUTH_CLIENT_ID_SCOPE_MAP = {
  '6148625015832406d3e9380d': SCOPE.RAVEN,
}

export const WEB_CLIENTS = [SCOPE.APP_NEAT_COM, SCOPE.SCANSNAP, SCOPE.SSP, SCOPE.NEAT_COM]
export const MOBILE_CLIENTS = [SCOPE.NEMO_IOS, SCOPE.NEMO_ANDROID]
export const DESKTOP_CLIENTS = [SCOPE.SCISSORS_MAC, SCOPE.SCISSORS_WINDOWS]
export const IOS_CLIENTS = [SCOPE.NEMO_IOS]
export const ANDROID_CLIENTS = [SCOPE.NEMO_ANDROID]
export const OAUTH_CLIENTS = [SCOPE.RAVEN]

export const AUTH_ERROR_MESSAGES = {
  notLinked: 'User is not linked.',
  notFound: 'User not found.',
}

export const ROUTES = {
  404: '/404',
  500: '/500',
  ssoLogin: '/sso-login',
  login: '/',
  maintenance: '/maintenance',
  recoverPassword: '/recover-password',
  resetPassword: '/reset-password',
  ssoSuccess: '/sso-success',
  ssoContinue: '/sso-continue',
  scanSnapAuthorization: '/scansnap/authorize',
  scanSnapAccounts: '/scansnap/authorize/accounts',
  authenticated: '/authenticated',
  invitationsLogin: '/invitations/login',
  createAccount: '/create-account',
  oauthAuthorization: '/oauth/authorize',
  mfa: '/mfa',
  loginTimeout: '/login-timeout',
} as const

export const SSO_SCOPE = {
  APPLE: 'APPLE',
  GOOGLE: 'GOOGLE',
  INTUIT: 'INTUIT',
}

export const QUERY_PARAMS = {
  callbackUrl: 'callbackUrl',
  debug: 'debug',
  scope: 'scope',
  targetRoute: 'targetRoute',
  showRememberMe: 'showRememberMe',
  clientId: 'clientId',
  invitationEmail: 'invitationEmail',
  invitationName: 'invitationName',
  invitationType: 'invitationType',
  tokenVersion: 'tokenVersion',
} as const

export const INTERNAL_QUERY_PARAMS = {
  accountExists: 'accountExists',
  ssoScope: 'ssoScope',
  oauthToken: 'oauthToken',
  jwt: 'jwt',
  rememberMe: 'rememberMe',
  createAccountSource: 'createAccountSource',
  authenticatedRedirectUrl: 'authenticatedRedirectUrl',
  fallbackAuthenticatedRedirectUrl: 'fallbackAuthenticatedRedirectUrl',
  refreshJWT: 'refreshJWT',
  jwtExpiresAt: 'jwtExpiresAt',
  refreshJWTExpiresAt: 'refreshJWTExpiresAt',
  validationId: 'validationId',
  validationCodeExpiresAt: 'validationCodeExpiresAt',
  validationEmail: 'validationEmail',
} as const

export const API_ERROR = {
  USER_LOCKED: 'USER_LOCKED',
  REQUEST_VALIDATION_FAILED: 'REQUEST_VALIDATION_FAILED',
  INVALID_VALIDATION_ID: 'INVALID_VALIDATION_ID',
}

export const AUTHENTICATION_METHOD = {
  CALLBACK_URL: 'CALLBACK_URL',
}

export const LOCKED_ERROR_TIMEOUT = 10000

export const AUTOMATION_SCOPE = 'NEAT_AUTOMATION_CABBIE'

export const LOGIN_TYPE = {
  invitation: 'invitation',
  oauth: 'oauth',
  signIn: 'signIn',
}

export const SCOPE_CLIENT_ID_MAP = {
  [SCOPE.SCISSORS_MAC]: '66b22803755f854b28a2b708',
  [SCOPE.SCISSORS_WINDOWS]: '66b22802755f854b28a2b707',
}

export const VALIDATOR_ERRORS = {
  CODE_NOT_CORRECT: 'CODE_NOT_CORRECT',
  CODE_NOT_VALID: 'CODE_NOT_VALID',
  CODE_VALIDATED: 'CODE_VALIDATED',
  TOO_MANY_REQUESTS: 'TOO_MANY_REQUESTS',
  VALIDATION_NOT_FOUND: 'VALIDATION_NOT_FOUND',
}

/* Types */
export type QueryParam = (typeof QUERY_PARAMS)[keyof typeof QUERY_PARAMS]
export type InternalQueryParam = (typeof INTERNAL_QUERY_PARAMS)[keyof typeof INTERNAL_QUERY_PARAMS]
export type ParamsObject = Record<QueryParam | InternalQueryParam, string | undefined>
